import * as Models from "../.";
export interface ISolarNoteResponse {
  accountNotes: Models.Customer.AccountNote.AccountNote[];
  count: string;
  types: string[];
  users: string[];
}

export class SolarNoteResponse implements ISolarNoteResponse {
  accountNotes: Models.Customer.AccountNote.AccountNote[];
  count: string;
  types: string[];
  users: string[];
}
